import { LockOutlined } from '@mui/icons-material';
import { Tooltip } from '@mui/material';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { Timer, PayoutOrderStatusLabel } from 'components';
import { HIDE_PAYOUT_TIMER_IN_STATUSES } from 'constants/order.constants';
import { PayoutOrderStatus } from 'enums';
import { TranslationNamespace } from 'i18n';
import { PayoutOrder } from 'types';
import { orderUtils } from 'utils';

type Props = {
  order: PayoutOrder;
};

export const PayoutOrderStatusColumn: React.FC<Props> = ({ order }) => {
  const { t } = useTranslation(TranslationNamespace.Common, {
    keyPrefix: 'features.payout_orders.labels',
  });

  const lockTooltip = useMemo(() => {
    if (order.lock?.lockReason) {
      return t(`lock_reason.${order.lock.lockReason}`, {
        defaultValue: order.lock.lockReason,
      });
    }
    return t('locked');
  }, [order.lock, t]);

  return (
    <div>
      {!HIDE_PAYOUT_TIMER_IN_STATUSES.includes(order.status) &&
        (order.currentCascadeAssigneeTimeoutAt &&
        order.status === PayoutOrderStatus.Requisites ? (
          <Timer
            hideTimeOver
            endTime={orderUtils.getOrderCurrentCascadeAssigneeTimeoutAt(order)}
          />
        ) : (
          <Timer hideTimeOver endTime={orderUtils.getMaxTimeoutAt(order)} />
        ))}
      <div>
        <div className="tw-flex tw-items-center tw-gap-1">
          {order.lock && (
            <Tooltip title={lockTooltip}>
              <LockOutlined sx={{ fontSize: 16, color: 'error.main' }} />
            </Tooltip>
          )}
        </div>
        <PayoutOrderStatusLabel status={order.status} />
      </div>
    </div>
  );
};
